import { useState } from 'react'
import styled from 'styled-components'
import { useStatisticsDashboard } from '../../api/hooks/use.statistics'
import { PeriodType } from '../../types/statistics.types'
import { LoaderWrapper, Spinner } from '../repair.work.page/incident.table.component/styled'
import { DistrictChartComponent } from './district.chart.component'

import { HeadingComponent } from '../../components/ui/heading.component'
import { MonthlyTrendChartComponent } from './monthly.trend.chart.component'
import { ProblemChartComponent } from './problem.chart.component'
import { SourceDistributionChartComponent } from './source.distribution.chart.component'
import { SummaryCardsComponent } from './summary.cards.component'

export const RepairWorkPageWrapper = styled.div`
	padding: 200px 10px 50px 10px;
	max-width: 1400px;
	margin: 0 auto;
	width: 95%;
	display: flex;
	flex-direction: column;
	gap: 20px;
`

export const PeriodWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 40px;

	@media(max-width: 768px) {
	 margin-bottom: 15px;
	}
`

export const PeriodBtn = styled.div<{ $active: boolean }>`
  font-family: 'e-Ukraine', sans-serif;
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 18px;
  border: 1.5px solid ${({ $active }) => ($active ? '#01924f' : 'transparent')};
  background: transparent;
  color: ${({ $active }) => ($active ? '#01924f' : '#8f8f8f')};
  cursor: pointer;
  line-height: 114%;
  transition: all 0.2s ease;

  &:hover {
    color: #01924f;
  }

  @media(max-width: 768px) {
     font-size: 11px;
	 padding: 8px 14px;
  }
	
  @media(max-width: 530px) {
	 padding: 5px 10px;
  }
`;

const PERIODS: { key: PeriodType; label: string }[] = [
	{ key: 'today', label: 'за поточну добу' },
	{ key: '7days', label: 'за 7 днів' },
	{ key: '30days', label: 'за 30 днів' },
]

export const getDateRange = (period: PeriodType): string => {
	const now = new Date()
	const fmt = (d: Date) =>
		d.toLocaleDateString('uk-UA', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		})
	if (period === 'today') return fmt(now)
	const days = period === '7days' ? 7 : 30
	const from = new Date(now)
	from.setDate(from.getDate() - days)
	return `${fmt(from)} – ${fmt(now)}`
}

export const StatisticsPage: React.FC = () => {
	const [period, setPeriod] = useState<PeriodType>('today')
	const { data, isLoading, isError } = useStatisticsDashboard(period)

	const dateRange = getDateRange(period)

	return (
		<RepairWorkPageWrapper>
			<HeadingComponent
				title="Статистика"
				description="Тут ви можете ознайомитися зі статистичними даними щодо звернень, що надходять до Контакт-Центру, зокрема їх кількістю, тематикою, статусами опрацювання та динамікою у визначені періоди"
				breadcrumbs={[
					{ title: 'Головна', path: '/' },
					{ title: 'Статистика', path: '/statistics' },
				]}
				/>

			<PeriodWrapper>
				{PERIODS.map(p => (
					<PeriodBtn
						key={p.key}
						$active={period === p.key}
						onClick={() => setPeriod(p.key)}
					>
						{p.label}
					</PeriodBtn>
				))}
			</PeriodWrapper>

			{isLoading ? (
				    <LoaderWrapper>
                <Spinner />
              </LoaderWrapper>
			) : data ? (
				<>
					<SummaryCardsComponent data={data.summary} dateRange={dateRange} />
					<MonthlyTrendChartComponent data={data.monthlyTrend} />
					<SourceDistributionChartComponent
						data={data.sourceDistribution}
						dateRange={dateRange}
					/>
					<DistrictChartComponent
						data={data.districtStats}
						dateRange={dateRange}
					/>
					<ProblemChartComponent
						data={data.problemStats}
						dateRange={dateRange}
					/>
				</>
			) : isError ? (
				<div>Помилка завантаження даних</div>
			) : null}
		</RepairWorkPageWrapper>
	)
}
